import { createFileRoute } from '@tanstack/react-router';
import { type AggregateBreadcrumb, buildBreadcrumb } from '@interxfi/app-components/components/router-breadcrumbs/router-breadcrumbs';
import { getPortfolioAssetBalancePath } from '../../../../../../../../../features/portfolio/asset-balance/portfolio-asset-balance-routing';
import { AccountBreadcrumb } from '../../../../../../../../../features/registration/account/account-breadcrumb';

export const Route = createFileRoute('/_app/_clearing-core/registration/account/$accountId/_account/_detail/asset/_asset')({
  loader: ({ params }) =>
    ({
      breadcrumb: buildBreadcrumb({
        id: `account-${params.accountId}-asset`,
        label: <AccountBreadcrumb accountId={params.accountId} displayIdOnly />,
        to: getPortfolioAssetBalancePath({ kind: 'list', keys: { accountId: params.accountId } }),
      }),
    }) satisfies AggregateBreadcrumb,
});
